import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    id: Number
  }

  select(event) {
    const userId = this.idValue
    const selectElement = document.querySelector('#user_selected_id')
    if (selectElement) {
      selectElement.value = userId
      selectElement.dispatchEvent(new Event('change'))
    }

    const modal = document.querySelector('#common_modal')
    if (modal) {
      modal.classList.add("hidden")
    }
  }
}